import UploadFileOutlinedIcon from '@mui/icons-material/UploadFileOutlined';
import { Box, Button, InputAdornment, TextField } from '@mui/material';
import React, { FC, useRef } from 'react';

interface InputFileProps {
	file: any;
	label: string;
	handleFileChange: (string, e) => void;
	type: string;
	disabled?: boolean;
}

export const InputFile: FC<InputFileProps> = ({ file, label, handleFileChange, type, disabled = false }) => {
	const ref = useRef<HTMLInputElement>(undefined);

	return (
		<Box position='relative' height={57} width='100%'>
			<Box position='absolute' width='100%'>
				<TextField
					fullWidth
					label={label}
					value={file ? file.name : ''}
					required
					disabled={disabled}
					sx={{ pointerEvents: 'none' }}
					InputProps={{
						endAdornment: (
							<InputAdornment position='end'>
								<UploadFileOutlinedIcon />
							</InputAdornment>
						),
					}}
				/>
			</Box>
			<Button
				className='inputButtons'
				component='label'
				onKeyDown={(e) => e.key === '32' && ref.current?.click()}
				fullWidth
				sx={{
					height: '100%',
					backgroundColor: 'transparent',
					'&:hover': {
						backgroundColor: 'transparent',
						boxShadow: 'none',
					},
				}}
				disabled={disabled}
			>
				<input
					ref={ref}
					type='file'
					onChange={(e) => handleFileChange(type, e)}
					accept='.csv'
					hidden
					data-cy='upload-file-input'
				/>
			</Button>
		</Box>
	);
};
